module.exports = __webpack_public_path__ + "img/Group 427320600.c541e948.png";